import { IRoute } from '../interfaces/routing';

import CarnetVacunacion from '../pages/gessoma/sintomatologia/Carnetvacunacion';
import Covid from '../pages/gessoma/sintomatologia/Covid';
import LoginElecciones from '../pages/gessoma/elecciones/login';
import Eleccion from '../pages/gessoma/elecciones/eleccion';
import ResultadoVoto from '../pages/gessoma/elecciones/resultado';
import EleccionHostigamiento from '../pages/gessoma/elecciones/eleccion-hostigamiento';

export const staticRoutes: IRoute[] = [
  {
    path: 'covid',
    component: Covid
  },
  {
    path: 'carnetvacunacion',
    component: CarnetVacunacion
  },
  {
    path: 'elecciones',
    component: LoginElecciones
  },
  {
    path: 'eleccion',
    component: Eleccion
  },
  {
    path: 'eleccion-hostigamiento',
    component: EleccionHostigamiento
  },
  {
    path: 'resultado-voto',
    component: ResultadoVoto
  }
];
